import { useContext } from 'react';

import { ExamDistributionByMonthContext } from './exam-distribution-by-month-provider';

function useExamDistributionByMonth() {
  const context = useContext(ExamDistributionByMonthContext);

  if (!context) {
    throw new Error(
      'useExamDistributionByMonth must be used within a ExamDistributionByMonthProvider',
    );
  }

  return context;
}

export { useExamDistributionByMonth };
